import React, { type ComponentProps } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { BagPaymentCta } from './BagPaymentCta';

// ─────────────────────────────────────────────────────────────────────────────

export const BagCheckoutSessionCta = (props: Props) => {
  const { formatMessage } = useIntl();
  const a11yLabel = formatMessage(messages.a11yLabel);

  return <BagPaymentCta icon="IconShare2" a11yLabel={a11yLabel} {...props} />;
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  a11yLabel: {
    defaultMessage: 'Open external payment method setup',
    description: 'Bag | Checkout Session CTA | A11y label',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = Required<
  Pick<ComponentProps<typeof BagPaymentCta>, 'message' | 'onPress' | 'isLoading'>
>;
